import { ActivityPlanning } from "./ActivityPlanning";
import { InfantFeedingType } from "./InfantFeedingType";
import { VaccineState } from "./VaccineState";
import { VaginalExperience } from "./VaginalExperience";

class OntarioObstetricalPostNatalHistory {
    public VaginalBirthExperienceItem: VaginalExperience[] = [];
    public CaesareanBirthExperience: ActivityPlanning = ActivityPlanning.Unknown;
    public Details: string;
    public BirthAttendant: string;
    public PregnancyOrBirthIssuesRequiringFollowUp: string;
    public BabyName: string;
    public BabyCareProvider: string;
    public BirthWeight?: string;
    public BabyHealthOrConcerns: string;
    public InfantFeeding: InfantFeedingType = InfantFeedingType.Unknown;
    public FeedingConcerns: string;
    public CurrentMedications: string;
    public BladderFunction: string;
    public EmotionalWellbeing: string;
    public BowelFunction: string;
    public Relationship: string;
    public SexualFunction: string;
    public PostpartumDepressionScreen: string;
    public LochiaOrMenses: string;
    public FamilySupportOrCommunityResources: string;
    public PerineumOrIncision: string;
    public IsSmoking?: boolean;
    public NumberOfCigarettesPerDay?: number;
    public IsDrinking?: boolean;
    public NumberOfDrinkPerWeek?: number;
    public TaceScreeningScore?: number; // T-ACE
    public UsesNonPrescribedSubstances?: boolean;
    public HasRubellaImmunity?: boolean;
    public RubellaImmunizationState: VaccineState[] = [];
    public InfluenzaImmunizationState: VaccineState[] = [];
    public InfluenzaImmunizationReceivedDate?: Date;
    public IsPertussisImmunizationUpToDate?: boolean;
    public PertussisImmunizationState: VaccineState[] = [];
    public OtherImmunizations: string;
    public LastPapTestDate?: Date;
    public LastPaptestResult: string;

    public constructor(fields?: Partial<OntarioObstetricalPostNatalHistory>) {
        Object.assign(this, fields);
    }
}

export { OntarioObstetricalPostNatalHistory };
